<template>
	<div style='height: 60vh'>
		<div
			style="
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 16px;
				padding: 12px 20px 0px;
			"
		>
            <div @click="cancelPayment" style="color: #07111b">
                <slot name="cancel-button-text">{{ $t('general.cancel') }}</slot>
            </div>
			<div style="font-size: 18px; font-weight: bold">{{ $t('order.payment') }}</div>
			<div @click="applyPayment" style="color: #07111b">
                <slot name="confirm-button-text">{{ $t('general.apply') }}</slot>
            </div>
		</div>
		<div style="border: 1px solid #d4d4d4; margin: 10px 0px"></div>
		<div>
			<cube-radio-group class="radioStyle" style="padding: 0px 10px">
				<div v-for="(payment, idx) in paymentList" :key="idx">
					<div
						style="
							display: flex;
							justify-content: space-between;
							align-items: center;
							padding-right: 20px;
						"
					>
						<div>
							<cube-radio :option="payment" v-model="selectedPayment" :key="idx">
								<div style="font-size: 15px; margin-left: 18px">
									<div style="font-size: 18px; font-weight: bold" v-if="payment.data">
										{{ payment.data.nickname || '' }}
										<br/>
										{{ payment.data.card_number || '' }}
										</div>
									<div>{{ payment.payment_name }}</div>
								</div>
							</cube-radio>
						</div>
					</div>
					<div style="border: 1px solid #d4d4d4; margin: 10px 0px"></div>
				</div>
				<div v-if="showAddCredit">
					<div
						style="
							display: flex;
							justify-content: flex-end;
							align-items: center;
							padding-right: 20px;
						"
					>
						<div>
							<div style="font-size: 15px; margin-left: 18px">
								<router-link :to="{ name: 'MemberCredits' }">
									<span class="iconfont">&#xe6e1;</span>{{ $t('payment.edit_credit') }}
								</router-link>
							</div>
						</div>
					</div>
				</div>
			</cube-radio-group>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import { Toast, Indicator } from 'mint-ui'
import { getPaymentList } from '../../../../api/memberPayment'

export default {
  data () {
    return {
      platform: 'h5',
      selectedPayment: '',
      paymentList: null,
      payments: null
    }
  },
  computed: {
    showAddCredit () {
      if (this.payments) { return this.payments.some(x => x.payment_code === 'credit_h5') }
    }
  },
  created: function () {
    this.getPaymentList()
  },
  methods: {
    ...mapActions({
      setPayment: 'setPayment'
    }),
    closeDialog () {
      this.setPayment(false)
    },
    applyPayment () {
		let payment = false;
		if (this.paymentList.length !== 0) {			
			let payment = this.paymentList[this.selectedPayment]
			payment.is_default = 1
			// editAddress(address, address.address_id).then(
			//   (response) => {
			Indicator.close()
		}

		this.$emit('updatePayment', payment)
		this.closeDialog()
		// this.getAddressList()
		// }, (error) => {
		//   Indicator.close()
		//   Toast(error.message)
		// })
    },
    cancelPayment() {
        this.$emit('updatePayment', false)
        this.closeDialog()
    },
    getPaymentList () {
      getPaymentList(this.platform).then(res => {
        this.paymentList = res.result.payment_list
        this.payments = res.result.payments
        let self = this
        this.paymentList.forEach(function (payment, idx) {
          payment.value = idx // radio button value
          if (payment.is_default === 1) {
			  self.selectedPayment = idx
          }
        })
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>

<style scoped>
.radioStyle >>> .border-top-1px,
.border-right-1px,
.border-bottom-1px,
.border-left-1px {
	position: inherit !important;
}

</style>
